var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DashboardWidget", {
    attrs: {
      items: _vm.items,
      "show-more-text": _vm.t("radio", "stations"),
      "show-more-url": _vm.showMoreUrl,
      loading: _vm.state === "loading"
    },
    scopedSlots: _vm._u([
      {
        key: "empty-content",
        fn: function() {
          return [
            _vm.emptyContentMessage
              ? _c("EmptyContent", {
                  attrs: { icon: _vm.emptyContentIcon },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "desc",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(_vm.emptyContentMessage) +
                                "\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3412504350
                  )
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }